module.exports = __webpack_public_path__ + "static/people_pop21-dff32ac297088c25af4c3af77818df72.png";